import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, Play, Pause } from 'lucide-react';
interface Props {
  onNext: () => void;
}
const options = [{
  id: 'a',
  text: '“The science is what stands out.”'
}, {
  id: 'b',
  text: '“The conversations are what matter most.”'
}, {
  id: 'c',
  text: '“The coffee is carrying the entire congress.”'
}];
export const Screen2Slider = ({
  onNext
}: Props) => {
  const [selected, setSelected] = useState<string | null>(null);
  const [revealed, setRevealed] = useState(false);
  const handleSelect = (id: string) => {
    if (revealed) return;
    setSelected(id);
    setTimeout(() => {
      setRevealed(true);
    }, 600);
  };
  return <div className="relative w-full h-full bg-slate-950 overflow-hidden flex flex-col" data-id="element-338">
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900 via-slate-950 to-slate-950" data-id="element-339" />

      {/* Mock Video Player */}
      <div className="relative h-64 w-full bg-black shrink-0" data-id="element-340">
        <video src="https://cdn.magicpatterns.com/uploads/5wPyLmrLcJy9mKAv4BEyBB/women.mp4" className="w-full h-full object-cover" autoPlay loop muted playsInline data-id="element-341" />
      </div>

      <div className="relative z-10 flex-1 flex flex-col p-6 pt-6" data-id="element-342">
        <motion.span initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="text-[10px] tracking-[0.3em] uppercase text-red-500 font-semibold mb-3" data-id="element-343">
          02 — Predict
        </motion.span>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-6" data-id="element-344">
          <p className="text-sm text-slate-400 italic mb-2" data-id="element-345">
            “We’re about to meet someone with a really interesting perspective…”
          </p>
          <h2 className="text-2xl font-bold text-white leading-tight" data-id="element-346">
            What do you think they’ll say?
          </h2>
        </motion.div>

        <div className="space-y-3 flex-1" data-id="element-347">
          {options.map((opt, i) => {
          const isSelected = selected === opt.id;
          const isCorrect = opt.id === 'b'; // Arbitrary correct answer for demo
          let buttonClass = 'w-full text-left p-4 rounded-2xl border transition-all duration-300 ';
          if (!revealed) {
            buttonClass += isSelected ? 'bg-red-600/20 border-red-500 text-white' : 'bg-slate-900/50 border-slate-800 text-slate-300 hover:border-slate-600';
          } else {
            if (isCorrect) {
              buttonClass += 'bg-green-500/20 border-green-500 text-white';
            } else if (isSelected) {
              buttonClass += 'bg-slate-800/50 border-slate-700 text-slate-500 opacity-50';
            } else {
              buttonClass += 'bg-slate-900/30 border-slate-800 text-slate-600 opacity-50';
            }
          }
          return <motion.button key={opt.id} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.2 + i * 0.1
          }} onClick={() => handleSelect(opt.id)} disabled={revealed} className={buttonClass} data-id="element-348">
                <div className="flex items-start" data-id="element-349">
                  <span className="text-xs font-bold text-slate-500 mr-3 mt-1 uppercase" data-id="element-350">
                    {opt.id}
                  </span>
                  <span className="text-sm font-medium leading-snug" data-id="element-351">
                    {opt.text}
                  </span>
                </div>
              </motion.button>;
        })}
        </div>

        <AnimatePresence data-id="element-352">
          {revealed && <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="mt-4" data-id="element-353">
              <button onClick={onNext} className="w-full bg-red-600 hover:bg-red-500 text-white font-semibold py-4 rounded-2xl flex items-center justify-center space-x-2 transition-all active:scale-[0.98]" data-id="element-354">
                <span data-id="element-355">Continue</span>
                <ArrowRight className="w-5 h-5" data-id="element-356" />
              </button>
            </motion.div>}
        </AnimatePresence>
      </div>
    </div>;
};